import React from 'react';
// Images
import MainImage from '../../assets/images/special/lady-cinder-main.webp';
// Videos
import MainVideo from '../../assets/video/lc1-1080.webm';
// Constants
import { CompanyName } from '../../utils/Constants';
import { Link } from 'react-router-dom';
import { ABOUT_PAGE_URL } from '../../utils/Routes';
import LazyVideo from '../common/LazyVideo';

function HomeAboutContainer() {
  return (
    <section id='about-me' className='grid w-full min-h-screen md:min-h-[80vh]'>
      <div className='grid md:grid-cols-2 px-8 md:px-16 lg:px-24'>
        <article className='grid w-full items-center py-24'>
          <div className='grid h-fit text-center md:w-2/3 md:mx-auto'>
            <div className='grid gap-y-6'>
              <h2
                id='about-heading'
                className='text-colour1 text-5xl lg:text-7xl font-titleFont'
              >
                About {CompanyName || 'Lady Cinder'}
              </h2>

              <p className='text-colour1 text-lg leading-relaxed text-center'>
                Award winning, multi Nominated, Los Angeles based, yet rarely
                contained by borders. I am a touring dominatrix, whose presence
                is as coveted as it is rare. I offer not sessions, but
                encounters—each one a carefully curated descent into desire,
                fear, and exquisite surrender.
              </p>

              <p className='text-colour1 text-lg leading-relaxed text-center'>
                With years of experience and an appetite for a vast spectrum of
                kinks and fetishes, I specialize in transforming indulgence into
                torment, and torment into transcendence. If you like it, I’ll
                torture you with it—until the line between agony and ecstasy
                blurs into something unforgettable.
              </p>

              <p className='text-colour1 text-lg leading-relaxed text-center'>
                Those fortunate enough to secure my time understand: this is not
                play, this is metamorphosis. I will infiltrate your mind, lick
                your synapses, and rewire your hunger until you no longer
                recognize yourself—only your need for me.
              </p>

              <p className='text-colour1 text-lg leading-relaxed text-center'>
                Fly Me To You is available for the select few who dare to invite
                danger and luxury into their own domain.
              </p>

              <p className='text-colour1 text-lg leading-relaxed text-center'>
                Whether in Los Angeles, on tour, or in the private sanctum of
                your choosing, I deliver not just domination but a life-altering
                experience you will never escape.
              </p>
            </div>

            <div className='grid'>
              <Link
                to={ABOUT_PAGE_URL}
                aria-label='Learn about Lady Cinder'
                className='grid place-items-center h-12 px-8 text-base uppercase tracking-widest text-colour1 underline underline-offset-8 decoration-colour6 decoration-2 hover:decoration-colour8 hover:text-colour8 focus:outline-none focus:ring-2 focus:ring-colour6 font-titleFont'
              >
                Learn About Me
              </Link>
            </div>
          </div>
        </article>

        {/* RIGHT: two tall portrait panels */}
        <section className='grid justify-center items-center'>
          <div className='grid md:grid-cols-2 gap-x-8 gap-y-2'>
            {/* portrait image */}
            <div className='grid overflow-hidden'>
              <img
                src={MainImage}
                alt={`${CompanyName} — portrait`}
                className='h-[50vh] md:h-[60vh] w-auto object-cover'
                loading='lazy'
                decoding='async'
              />
            </div>

            {/* portrait video, same size, offset vertically */}
            <div className='grid md:pt-16 overflow-hidden'>
              <LazyVideo
                src={MainVideo}
                ariaLabel={`${CompanyName} — teaser video`}
                className='h-[50vh] md:h-[60vh] w-full md:w-auto object-cover'
              />
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}

export default HomeAboutContainer;
